import { ScrollReveal } from "./ScrollReveal";

export const VideoSection = () => {
  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-gray-50/50 to-white">
      <div className="container">
        <ScrollReveal>
          <h2 className="section-heading">
            Zobacz nas <span className="gradient-text">w akcji</span>
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
          <div className="max-w-4xl mx-auto">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-brand-purple/10">
              <div className="aspect-video">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/Wjd8tuRphjw"
                  title="Występ komediowy dla firm"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </ScrollReveal>
        <ScrollReveal delay={0.3}>
          <p className="text-center mt-10 text-gray-500 max-w-2xl mx-auto text-lg leading-relaxed">
            Każdy występ jest dostosowany do potrzeb Twojej firmy i charakteru wydarzenia. 
            Gwarantujemy profesjonalizm i świetną zabawę!
          </p>
        </ScrollReveal>
      </div>
    </section>
  );
};
